import { GetPageVm } from "../../models/view/get-page.vm";

export class GetPageParamCommand {
    constructor(public getPage: GetPageVm) {
    }
}
